import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type SliderTitleDiscountClasses = 'container' | 'priceValue' | 'label';

const sliderTitleDiscountStyles = makeStyles<ISpcTheme, SliderTitleDiscountClasses>(
  theme => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
    },
    label: {
      color: theme.palette.primary.main,
      fontSize: theme.typography.fontSM,
      fontWeight: 'bold',
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.fontXS,
      },
    },
    priceValue: {
      color: theme.palette.primary.main,
      fontSize: theme.typography.fontLG,
      fontWeight: 'bold',
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.fontMD,
      },
    },
  }),
  { name: 'Customise_sliderTitleDiscount' },
);

export default sliderTitleDiscountStyles;
